/* ============================================================
   blog-grid.js  –  Season Journals blog index interactions
   Upload to: Shopify Admin > Online Store > Themes > Assets
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('sjFilterToggle');
    var pillsWrap = document.getElementById('sjFilterPills');

    if (!toggle || !pillsWrap) return;

    toggle.addEventListener('click', function () {
      var isOpen = pillsWrap.classList.toggle('is-open');
      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
    });

    // Scroll the active pill into view on page load (useful on tagged pages)
    var activePill = document.querySelector('.sj-pill--active');
    if (activePill) {
      activePill.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  });
})();
